import React, { useState } from 'react';
import { Folder, FolderOpen, ChevronRight, ChevronDown } from 'lucide-react';

// Component đệ quy cho từng item trong cây
const TreeItem = ({ item, level = 0 }) => {
    const [isOpen, setIsOpen] = useState(true); // Trạng thái đóng/mở của node
    const hasChildren = item.children && item.children.length > 0;

    return (
        <div className="select-none">
            {/* Hàng hiển thị của đơn vị */}
            <div
                className={`flex items-center justify-between p-2 rounded-lg cursor-pointer transition-colors hover:bg-gray-50 dark:hover:bg-gray-700/50 ${level === 0 ? 'bg-blue-50 dark:bg-blue-950/40 text-blue-600 dark:text-blue-400 font-medium' : 'text-gray-700 dark:text-gray-300'
                    }`}
                style={{ paddingLeft: `${level * 16 + 8}px` }} // Thụt lề tự động theo cấp độ (level)
                onClick={() => hasChildren && setIsOpen(!isOpen)}
            >
                <div className="flex items-center gap-2 truncate">
                    {/* Nút bấm đóng/mở nếu có thư mục con */}
                    {hasChildren ? (
                        <span className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
                            {isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                        </span>
                    ) : (
                        <span className="w-4" /> // Khoảng trống giữ thẳng hàng nếu không có con
                    )}

                    {/* Icon thư mục thay đổi theo trạng thái mở/đóng */}
                    {isOpen ? <FolderOpen size={16} className="text-blue-500 shrink-0" /> : <Folder size={16} className="text-blue-500 shrink-0" />}

                    <span className="text-sm truncate">{item.name}</span>
                </div>
            </div>

            {/* Số lượng quy trình phụ đề */}
            <div className="text-xs text-gray-400 pb-1" style={{ paddingLeft: `${level * 16 + 32}px` }}>
                {item.count}
            </div>

            {/* Đệ quy render các cấp con bên trong khi mở */}
            {hasChildren && isOpen && (
                <div className="space-y-1">
                    {item.children.map((child) => (
                        <TreeItem key={child.id} item={child} level={level + 1} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default TreeItem;